import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { apiClient } from '../../../api/client/axios';
import { showSnackbar } from '../../../store/snackbarSlice';

const fetchSubscriptionUsage = async (query) => {
  const [, subscriptionId, params] = query.queryKey;
  const { data } = await apiClient.get(`/subscriptions/${subscriptionId}/usage`, { params });

  return data;
};

export const useGetSubscriptionUsageHandler = (subscriptionId, params = {}, { enabled = true } = {}) => {
  const dispatch = useDispatch();
  const [usage, setUsage] = useState(undefined);
  const hasParams = Boolean(params?.stripe_invoice_id || (params?.period_start != null && params?.period_end != null));

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['subscription-usage', subscriptionId, params],
    queryFn: fetchSubscriptionUsage,
    enabled: Boolean(subscriptionId) && hasParams && enabled,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (data) setUsage(data);
  }, [data]);

  useEffect(() => {
    if (!isError) return;

    if (error instanceof AxiosError) {
      dispatch(showSnackbar({ message: error.response?.data?.message || error.message, severity: 'error' }));

      return;
    }

    dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
  }, [dispatch, error, isError]);

  return { usage, isLoading, isError };
};
